import React, { Component } from 'react'
import Select from 'renanol-select'
import Scrollbars from 'react-custom-scrollbars'
import './../select.css'

const menuRenderer = (params) => {
  // use default renderer in a hacky way
  const menu = Select.defaultProps.menuRenderer(params)
  const scrollBarProps = {
    autoHeight: true,
    autoHeightMin: 0,
    autoHeightMax: 200
  }

  return (
    <Scrollbars {...scrollBarProps}>
      {menu}
    </Scrollbars>
  )
}

class SelectSegments extends Component {
  state = {
    value: null
  }

  setValue = (value) => {
    const {type, changeFilter} = this.props
    const currentIds = Array.isArray(value) ? value.map((item) => item.value) : value.value
    this.setState({ value })
    changeFilter(type, currentIds)
  }
  resetValue = () => {
    this.setState({value: null})
  }

  componentDidUpdate (prevProps) {
    const {options} = this.props
    if (options.length !==  prevProps.options.length) this.resetValue()
  }

  render () {
    const { 
      options,
      isLoading,
      placeholder,
      multi,
      clearable,
      searchable,
      disabled
    } = this.props
    
    const { value } = this.state
    return (
      <Select
        multi={multi}
        clearable={clearable}
        onChange={this.setValue}
        options={options}
        value={value}
        searchable={searchable}
        className='select--filter'
        isLoading={isLoading}
        placeholder={placeholder}
        menuRenderer={menuRenderer}
        disabled={disabled}
      />
    )
  }
}

export default SelectSegments



// WEBPACK FOOTER //
// ./src/components/Select/Books/SelectSegments.js